import React from 'react'
import * as Yup from 'yup'
import { FormikStepProps } from '../../../components/form/wizzard/FormikStepper'
import { AdGroupCreateInput, AdGroupInput, PriorityListQuery } from '../../../__generated__/graphql'
import { EditionModeContextProvider, EditionModes } from '../../../utils/providers/editionModeContext'
import InfosFields from '../settings/adGroupDetails/InfosFields'
import { networkSchema } from '../schema'

export const detailsSchema = Yup.object().shape({
  name: Yup.string().min(3).required('commons.required'),
  isActive: Yup.boolean().required('commons.required'),
  ...networkSchema.fields,
  campaignId: Yup.string().required('commons.required'),
  format: Yup.string().required('commons.required'),
})

export const detailsSchemaWithoutCampaign = Yup.object().shape({
  name: Yup.string().min(3).required('commons.required'),
  isActive: Yup.boolean().required('commons.required'),
  ...networkSchema.fields,
  format: Yup.string().required('commons.required'),
})

const AdgroupDetailStep: React.FC<
  FormikStepProps & {
    adgroup: AdGroupInput | AdGroupCreateInput
    priorityList: PriorityListQuery['campaign']['advertiser']['reseller']['priorities']
    hideCampaignSelector?: boolean
  }
> = ({ adgroup, priorityList, hideCampaignSelector = false }) => {
  return (
    <EditionModeContextProvider defaultMode={EditionModes.Edition}>
      <InfosFields
        adgroup={adgroup}
        creatingAdgroup={true}
        priorityList={priorityList}
        hideCampaignSelector={hideCampaignSelector}
      />
    </EditionModeContextProvider>
  )
}

export default AdgroupDetailStep
